
  import { QBreadcrumbs, QBreadcrumbsEl, QBtn, QCard, QCardSection, QSpinner, QTable, QTd, QTr, QPage } from 'quasar'
  import { FormShareModal, FormViewerLegacy, NewFileManager, dateUtils } from '@parantion/components'
  import TemplateModal from './templateModal.vue'
  import NoTaskDialog from './NoTaskDialog.vue'
  import ReportModal from './reportModal.vue'
  import DataFab from '@/components/datafab/datafab.vue'
  import { Component, Prop, Vue, Watch } from 'vue-property-decorator'
  const { convertDateFormatToISO_8601 } = dateUtils

  @Component({
    components: {
      FormShareModal,
      FormViewerLegacy,
      TemplateModal,
      QBtn,
      QPage,
      QCardSection,
      QCard,
      QBreadcrumbs,
      QBreadcrumbsEl,
      NewFileManager,
      QTable,
      QTd,
      QTr,
      DataFab,
      QSpinner,
      NoTaskDialog
    }
  })
  export default class Student extends Vue {
    @Prop() groupName: string
    @Prop() studentid: string

    parameters = [{
      name: 'generateReport',
      type: 'boolean',
      label: this.$t('formshare.sharemodal.generate_report.modalbody'),
      value: false
    }]

    pagination = {
      page: 1,
      rowsPerPage: 25 // current rows per page being displayed
    }

    keywords = ['voornaam leerling', 'achternaam leerling', 'link', 'naam ib-er']

    linkMail = {
      title: this.$t('student.link_mail_title.mail'),
      body: this.$t('student.link_mail_body.mail'),
    }

    codeMail = {
      title: this.$t('student.code_mail_title.mail'),
      body: this.$t('student.code_mail_body.mail'),
    }

    link = 'https://erasmusifms.viewform.nl/?form=7b3bfb89834842dd1f5236e3b4e09fb6&uid=672d38b8e533caac669061299ed0b41e'
    fid = ''
    form: any = {}
    refresh = false
    translationState = this.$getTranslationOptions()
    columns = this.createColumns(this.$t)
    loading = false
    actionsConfig = {
      primary: {
        icon: 'assignment', tooltip: 'tooltip.opendocument.1', handler: document => this.openForm(document)
      },
      actions: [
        {
          icon: 'share',
          tooltip: 'student.share.tooltip',
          handler: document => {
            this.form = document
            this.openShareModal(document)
          }
        },
        {
          icon: 'assignment',
          tooltip: 'student.generate_report.tooltip',
          handler: document => this.initGenerateReport(document)
        },
        // TODO API {icon: 'attach_file', tooltip: 'student.attach_files.tooltip', handler: () => this.$refs.attachmodal.open()},
        { icon: 'lock', tooltip: 'student.lock_document.tooltip', handler: document => this.lockDocument(document) }
      ]
    }

    field: any = []
    $store: any

    @Watch('translationState')
    translationStateWatcher () {
      this.columns = this.createColumns(this.$t)
    }

    openFileModalForStudent () {
      // @ts-ignore
      this.$refs.studentFileManager.init()
      // @ts-ignore
      this.$refs.studentFileManager.$refs.fileManagerModal.$refs.fileManagerModal.show()
    }

    async onShare (recipients) {
      recipients.fid = this.fid
      recipients.student = this.student

      if (recipients.recipients[0].tih) { // update ticket
        await this.$store.dispatch('groups/updateTicket', recipients)
        if (recipients.sendAgain) this.$toasty.success(this.$t('student.share_successful.toast'))
      } else {
        recipients.student = this.student
        await this.$store.dispatch('groups/createTickets', recipients)
        this.$toasty.success(this.$t('student.share_successful.toast'))

        const reportParam = recipients.parameters.find(param => param.name === 'generateReport')
        if (reportParam && reportParam.value === true) {
          const frm = this.growDocuments.find(gd => gd.fh === this.fid)
          this.initGenerateReport(frm)
        }
      }
    }

    onDeleteTicket (ticket) {
      this.$store.dispatch('groups/deleteTickets', ticket)
    }

    initGenerateReport (form) {
      this.$store.dispatch('parantion/newfiles/setUserId', this.student.uh)
      this.form = form

      this.$q.dialog({
        component: ReportModal,
        parent: this,
        student: this.student,
        form: form
      })
      // @ts-ignore
      // this.$refs.reportModal.open()
    }

    openShareModal (form) {
      this.$store.dispatch('groups/retrieveTickets')
      this.fid = form.fh

      // @ts-ignore
      this.$refs.sharemodal.open()
    }

    async setupTask (form) {
      // @ts-ignore
      const promise = this.$refs.taskDialog.show(form, this.$refs.formviewer)
      await this.$store.dispatch('groups/makeTicketForDocument', form)

      try {
        await promise
      } catch (e) {
        console.log('Cancelled')
      }
    }

    // fixme does this work with fid
    openForm (form) {
      if (this.student.status === 'inactive') return
      const task = this.$store.state.groups.tasks.find(t => t.fh === form.fh)
      if (!task) { // Old form, we need to make a ticket
        this.setupTask(form)
      } else {
        // @ts-ignore
        this.$refs.formviewer.open(task.link.replace(/http(s)?/, 'https'))
      }
    }

    async lockDocument (form) {
      const isOpen = form.frm_status === 1
      const previousStatus = form.frm_status
      this.$q.dialog({
        title: `Groeidocument ${isOpen ? 'sluiten' : 'openen'}`,
        message: `Weet u zeker dat u dit groeidocument wilt ${isOpen ? 'sluiten' : 'openen'}?`,
        ok: isOpen ? 'sluiten' : 'openen',
        cancel: 'Annuleren'
      }).onOk(() => {
        form = this.growDocuments.find(f => f.fh === form.fh)
        form.frm_status = form.frm_status === 1 ? 0 : 1
        this.$store.dispatch('groups/closeForm', form)
      })
        .onCancel(() => {
          form.frm_status = previousStatus
        })
    }

    async submitDocument (template) {
      await this.$store.dispatch('groups/addDocument', {
        module: 'Form',
        users: [this.studentid],
        template: template.value,
        frm_label: template.label
      })
      // @ts-ignore
      this.$refs.templateModal.close()
    }

    createColumns ($t) {
      return [
        {
          name: 'frm_date_created',
          label: $t('studenttable.date.label'),
          type: 'date',
          align: 'left',
          field: 'frm_date_created',
          format: date => date ? convertDateFormatToISO_8601(date, 'dd MMMM yyy HH:mm') : '-'
        },
        {
          name: 'frm_status',
          label: $t('studenttable.status.label'),
          field: 'frm_status',
          align: 'left',
          format: x => x === 0 ? 'gesloten' : 'open'
        },
        {
          name: 'frm_label',
          label: $t('studenttable.template.label'),
          align: 'left',
          field: 'frm_label'
        },
        {
          name: 'shareLinkCount',
          label: $t('studenttable.sharelink_count.label'),
          field: 'shareLinkCount'
        },
        {
          label: $t('studenttable.actions.label'),
          classes: 'action-column',
          name: 'actions',
          field: 'message',
          width: '250px'
        }
      ]
    }

    createDocument () {
      // @ts-ignore
      this.$refs.templateModal.open()
    }

    get computedFilemanagerSubtitle () {
      return `Bestanden van ${this.fullName} `
    }

    get fullName () {
      return `${(this.student.firstname || '') + ' '}${this.student.middlename ? this.student.middlename + ' ' : ''}${this.student.lastname || ''}`
    }

    get group () {
      return this.$store.getters['groups/getGroupByName'](this.groupName)
    }

    get studentIsActive () {
      return this.student.status === 'active'
    }

    get student () {
      return this.$store.getters['groups/getUserById'](this.studentid, this.groupName)
    }

    get templates () {
      return this.$store.state.base.templates.filter(t => t.type === 'form').map(t => ({
        label: t.label,
        value: t.tn
      }))
    }

    get growDocuments () {
      return this.$store.getters['groups/formsForUser'](this.student.uh).map(form => {
        return {
          ...form,
          task: this.$store.state.groups.tasks.find(task => task.fid === form.fh),
          shareLinkCount: this.$store.state.groups.tickets.filter(t => t.fid === form.fh && t.email).length
        }
      })
    }

    get tickets () {
      return this.$store.state.groups.tickets.filter(t => t.fid === this.fid && t.email) || []
    }

    get emails () {
      // Using set to ensure uniqueness
      // const allEmails = new Set(this.$store.getters.getAllUsers.map(user => user.email))
      // return [...allEmails]
      return []
    }

    get accountIsValid () {
      if (this.field.account_valid) {
        const validDate = new Date(this.field.account_valid)
        const today = new Date()
        return validDate > today
      }
      return true
    }

    async getFields () {
      this.field = await this.$store.dispatch('groups/getUserFields', this.student.uh)
    }

    created () {
      this.$store.dispatch('groups/retrieveGroups')
      this.$store.dispatch('groups/retrieveTickets')
      this.$store.dispatch('groups/retrieveFormsFromUser', { force: true, uid: this.student.uh })

      this.$store.dispatch('base/retrieveTemplates')

      this.getFields().then(() => { this.loading = false })

      // axios.get('/v51/user/' + this.student.uh + '/field').then(res => {
      //   this.field = res.data.field
      // })
    }
  }

